// export const AppNames: AppNameType[] = ['admin', 'tenant', 'merchant', 'consumer', 'api', 'home'];
import { dataId } from '@/utils/types/common';
import AdminFile from '@/services/admin/Base/AdminBaseFile';
import { UploadVo } from '@/services/admin/AdminTypings';
import { getAppName, getId, urlPath } from '@/utils/CommonUtils';
import TenantFile from '@/services/tenant/Base/TenantBaseFile';
import MerchantFile from '@/services/merchant/Base/MerchantBaseFile';
import ConsumerFile from '@/services/consumer/Base/ConsumerBaseFile';
import ApiFile from '@/services/api/Base/ApiBaseFile';
import HomeFile from '@/services/home/Base/HomeBaseFile';

//
export const adminFileUrl = async (fileId: dataId): Promise<UploadVo | undefined> => {
  if (!fileId) {
    return undefined;
  }
  const id = getId(fileId);
  if (!id) {
    return undefined;
  }
  let data: UploadVo = await AdminFile.url(id, {
    skipErrorHandler: true,
  });
  if (!data) {
    return undefined;
  }
  if (data.privateRead) {
    data.url = urlPath(`/admin${data.url}`);
  }
  return data;
};

export const tenantFileUrl = async (fileId: dataId): Promise<UploadVo | undefined> => {
  if (!fileId) {
    return undefined;
  }
  const id = getId(fileId);
  if (!id) {
    return undefined;
  }
  let data: UploadVo = await TenantFile.url(id, {
    skipErrorHandler: true,
  });
  if (!data) {
    return undefined;
  }
  if (data.privateRead) {
    data.url = urlPath(`/tenant${data.url}`);
  }
  return data;
};

export const merchantFileUrl = async (fileId: dataId): Promise<UploadVo | undefined> => {
  if (!fileId) {
    return undefined;
  }
  const id = getId(fileId);
  if (!id) {
    return undefined;
  }
  let data: UploadVo = await MerchantFile.url(id, {
    skipErrorHandler: true,
  });
  if (!data) {
    return undefined;
  }
  if (data.privateRead) {
    data.url = urlPath(`/merchant${data.url}`);
  }
  return data;
};

export const consumerFileUrl = async (fileId: dataId): Promise<UploadVo | undefined> => {
  if (!fileId) {
    return undefined;
  }
  const id = getId(fileId);
  if (!id) {
    return undefined;
  }
  let data: UploadVo = await ConsumerFile.url(id, {
    skipErrorHandler: true,
  });
  if (!data) {
    return undefined;
  }
  if (data.privateRead) {
    data.url = urlPath(`/consumer${data.url}`);
  }
  return data;
};

export const apiFileUrl = async (fileId: dataId): Promise<UploadVo | undefined> => {
  if (!fileId) {
    return undefined;
  }
  const id = getId(fileId);
  if (!id) {
    return undefined;
  }
  let data: UploadVo = await ApiFile.url(id, {
    skipErrorHandler: true,
  });
  if (!data) {
    return undefined;
  }
  if (data.privateRead) {
    data.url = urlPath(`/api${data.url}`);
  }
  return data;
};

export const homeFileUrl = async (fileId: dataId): Promise<UploadVo | undefined> => {
  if (!fileId) {
    return undefined;
  }
  const id = getId(fileId);
  if (!id) {
    return undefined;
  }
  let data: UploadVo = await HomeFile.url(id, {
    skipErrorHandler: true,
  });
  if (!data) {
    return undefined;
  }
  if (data.privateRead) {
    data.url = urlPath(`/home${data.url}`);
  }
  return data;
};

export const fileUrl = async (fileId: dataId): Promise<UploadVo | undefined> => {
  const appName: AppNameType = getAppName();
  switch (appName) {
    case 'tenant':
      return tenantFileUrl(fileId);
    case 'merchant':
      return merchantFileUrl(fileId);
    case 'consumer':
      return consumerFileUrl(fileId);
    case 'api':
      return apiFileUrl(fileId);
    case 'home':
      return homeFileUrl(fileId);
    default:
      return adminFileUrl(fileId);
  }
};

//
export const adminFileUrlList = async (
  idList: dataId[] | undefined,
): Promise<UploadVo[] | undefined> => {
  if ((idList || []).length < 1) {
    return undefined;
  }
  const ids: number[] = (idList || []).filter((v) => getId(v) > 0).map((v) => getId(v));
  if ((ids || []).length < 1) {
    return undefined;
  }
  const data: UploadVo[] = await AdminFile.urlList(ids, {
    skipErrorHandler: true,
  });
  if ((data || []).length < 1) {
    return undefined;
  }
  return data.map((v) => {
    return {
      ...v,
      url: v.privateRead ? urlPath(`/admin${v.url}`) : v.url,
    };
  });
};

export const tenantFileUrlList = async (
  idList: dataId[] | undefined,
): Promise<UploadVo[] | undefined> => {
  if ((idList || []).length < 1) {
    return undefined;
  }
  const ids: number[] = (idList || []).filter((v) => getId(v) > 0).map((v) => getId(v));
  if ((ids || []).length < 1) {
    return undefined;
  }
  const data: UploadVo[] = await TenantFile.urlList(ids, {
    skipErrorHandler: true,
  });
  if ((data || []).length < 1) {
    return undefined;
  }
  return data.map((v) => {
    return {
      ...v,
      url: v.privateRead ? urlPath(`/tenant${v.url}`) : v.url,
    };
  });
};

export const merchantFileUrlList = async (
  idList: dataId[] | undefined,
): Promise<UploadVo[] | undefined> => {
  if ((idList || []).length < 1) {
    return undefined;
  }
  const ids: number[] = (idList || []).filter((v) => getId(v) > 0).map((v) => getId(v));
  if ((ids || []).length < 1) {
    return undefined;
  }
  const data: UploadVo[] = await MerchantFile.urlList(ids, {
    skipErrorHandler: true,
  });
  if ((data || []).length < 1) {
    return undefined;
  }
  return data.map((v) => {
    return {
      ...v,
      url: v.privateRead ? urlPath(`/merchant${v.url}`) : v.url,
    };
  });
};

export const consumerFileUrlList = async (
  idList: dataId[] | undefined,
): Promise<UploadVo[] | undefined> => {
  if ((idList || []).length < 1) {
    return undefined;
  }
  const ids: number[] = (idList || []).filter((v) => getId(v) > 0).map((v) => getId(v));
  if ((ids || []).length < 1) {
    return undefined;
  }
  const data: UploadVo[] = await ConsumerFile.urlList(ids, {
    skipErrorHandler: true,
  });
  if ((data || []).length < 1) {
    return undefined;
  }
  return data.map((v) => {
    return {
      ...v,
      url: v.privateRead ? urlPath(`/consumer${v.url}`) : v.url,
    };
  });
};

export const apiFileUrlList = async (
  idList: dataId[] | undefined,
): Promise<UploadVo[] | undefined> => {
  if ((idList || []).length < 1) {
    return undefined;
  }
  const ids: number[] = (idList || []).filter((v) => getId(v) > 0).map((v) => getId(v));
  if ((ids || []).length < 1) {
    return undefined;
  }
  const data: UploadVo[] = await ApiFile.urlList(ids, {
    skipErrorHandler: true,
  });
  if ((data || []).length < 1) {
    return undefined;
  }
  return data.map((v) => {
    return {
      ...v,
      url: v.privateRead ? urlPath(`/api${v.url}`) : v.url,
    };
  });
};

export const homeFileUrlList = async (
  idList: dataId[] | undefined,
): Promise<UploadVo[] | undefined> => {
  if ((idList || []).length < 1) {
    return undefined;
  }
  const ids: number[] = (idList || []).filter((v) => getId(v) > 0).map((v) => getId(v));
  if ((ids || []).length < 1) {
    return undefined;
  }
  const data: UploadVo[] = await HomeFile.urlList(ids, {
    skipErrorHandler: true,
  });
  if ((data || []).length < 1) {
    return undefined;
  }
  return data.map((v) => {
    return {
      ...v,
      url: v.privateRead ? urlPath(`/home${v.url}`) : v.url,
    };
  });
};

export const fileUrlList = async (
  idList: dataId[] | undefined,
): Promise<UploadVo[] | undefined> => {
  const appName: AppNameType = getAppName();
  switch (appName) {
    case 'tenant':
      return tenantFileUrlList(idList);
    case 'merchant':
      return merchantFileUrlList(idList);
    case 'consumer':
      return consumerFileUrlList(idList);
    case 'api':
      return apiFileUrlList(idList);
    case 'home':
      return homeFileUrlList(idList);
    default:
      return adminFileUrlList(idList);
  }
};

export const fileViewUrl = (fileId: dataId): string => {
  const appName: AppNameType = getAppName();
  return urlPath(`/${appName.trim().toLowerCase()}/file/response/${fileId}`);
};

export const fileUploadUrl = (isPublic: boolean = false): string => {
  const appName: AppNameType = getAppName();
  if (isPublic) {
    return urlPath(`/${appName.trim().toLowerCase()}/uploader/upload/public`);
  }
  return urlPath(`/${appName.trim().toLowerCase()}/uploader/upload`);
};
